import { CaseStudy } from '../../types';

export const gatvol: CaseStudy = {
  id: '10',
  title: 'GatVol',
  category: 'Community Pulse',
  imageUrl: 'https://images.unsplash.com/photo-1577495508048-b635879837f1?q=80&w=1200&auto=format&fit=crop',
  description: 'A platform for citizens to voice concerns and track community issues. GatVol connects people with progress, turning frustration into action.',
  screenshots: [],
  comingSoon: true
};